import http from './http'


// 获取首页
export const getHomedata = () => http.get("/randomhow/api/home");

// 随机
export const getRandomdata = () => http.get("/randomhow/api/randomlist.json") ;

// 获取详情页
export const getDetailsdata = (para) =>  http.get("/randomhow/api/article?" + para);

// 获取搜索页 
// export const getSearchdata = (para) => http.get("/api/search" + para)